import { CALENDAR } from "@client/actions";
import { Action } from "@client/lib/action";
import { EmailEditForm, ActionCodeInfo, RegisterEmailForm, AuthCredential, LoginForm, User, AuthCodeInfo, ForgotPasswordForm, ResetPasswordForm, UpdatePasswordForm, Session, FaqDataInfo, FaqInfo, OrganizationInfo, SectorInfo, ContractInfo, ParkInfo, ServiceInfoWithGroup, SubscriptionService, ContractForm } from "@client/utils/shared-constants";

export class CalendarDestroyAction implements Action {
    readonly type = CALENDAR.DESTROY;
    constructor(public payload?: null, public correlationId?: number) {
    }
}

export class CalendarInitAction implements Action {
    readonly type = CALENDAR.INIT;
    constructor(public payload?: null, public correlationId?: number) {
    }
}
